require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-gruppo-di-ricerca-riccardo-bergossi.json") })
        }
      }, "path---en-gruppo-di-ricerca-riccardo-bergossi");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-gruppo-di-ricerca-riccardo-bergossi!./.cache/json/en-gruppo-di-ricerca-riccardo-bergossi.json
// module id = 576
// module chunks = 231608221292675